import Button, { ButtonProps } from '@lyra/core/components/Button'
import { useState } from 'react'

import DrvStakeModal from './DrvStakeModal'

type Props = Omit<ButtonProps, 'onPress'>

export default function DrvStakeButton({ ...props }: Props) {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      <Button
        {...props}
        label="Stake"
        onPress={(e) => {
          e.stopPropagation()
          setIsOpen(true)
        }}
      />
      {isOpen ? <DrvStakeModal onClose={() => setIsOpen(false)} /> : null}
    </>
  )
}
